import React from "react";
import { useBreadcrumb } from "./../hooks/useBreadcrumb";
import ScoreDashboard from "../components/ScoreDashboard";

/**
 * Workspace → Overview.
 *
 * Shows how every site-level agent's score has moved for the selected
 * project. `projects` comes from App.js and is null until the list has
 * loaded — ScoreDashboard treats that as loading rather than "no projects".
 */
export default function OsMainScreen({ projects, quota = null }) {
  useBreadcrumb([
    { label: "Workspace", to: "/mainScreen" },
    { label: "Overview" },
  ]);

  return (
    <section className="wrapper__os__overview">
      <ScoreDashboard projects={projects} quota={quota} />
    </section>
    // <section className="wrapper__os__mainScreen">
    //     <div className="wrapper__search__console mw__672">
    //         <div className="head text__center">
    //             <h2 className="h1 fc__0E1218 mb__40 fw__700">What shall we look into, Vibhu?</h2>
    //         </div>
    //         <div className="wrapper__search__input">
    //             <input type="text" name="" id="query" placeholder="Pick Your SEO Assistant" />
    //             <button type="button" className="btn-pick-assistant">
    //                 <span className="icon-plus"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    //                     <rect x="0.5" y="0.5" width="31" height="31" rx="11.5" fill="#FDFCFA" />
    //                     <rect x="0.5" y="0.5" width="31" height="31" rx="11.5" stroke="#E7E4E0" />
    //                     <path d="M11.333 16H20.6663" stroke="#5F636A" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
    //                     <path d="M16 11.333V20.6663" stroke="#5F636A" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
    //                 </svg></span>
    //             </button>
    //         </div>
    //     </div>
    // </section>
  );
}
